import { apiSlice } from "../../app/api/apiSlice";

export const adminApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getContactMessages: builder.query({
      query: () => "/contact/admin/messages",
      providesTags: ["ContactMessages"],
    }),
    markMessageRead: builder.mutation({
      query: (id) => ({
        url: `/contact/admin/messages/${id}/read`,
        method: "PUT",
      }),
      invalidatesTags: ["ContactMessages"],
    }),
    deleteMessage: builder.mutation({
      query: (id) => ({
        url: `/contact/admin/messages/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["ContactMessages"],
    }),

    getAdminProfile: builder.query({
      query: () => "/user/profile",
      providesTags: ["AdminProfile"],
    }),
    updateAdminProfile: builder.mutation({
      query: (formData) => ({
        url: "/user/profile",
        method: "PUT",
        body: formData, // FormData manages file binary streams
      }),
      invalidatesTags: ["AdminProfile"],
    }),

    changeAdminPassword: builder.mutation({
      query: (passwordData) => ({
        url: "/user/change-password",
        method: "PUT",
        body: passwordData,
      }),
    }),

    getMilestones: builder.query({
      query: () => "/milestones",
      providesTags: ["Milestones"],
    }),
    updateMilestones: builder.mutation({
      query: (stats) => ({
        url: "/milestones",
        method: "PUT",
        body: stats,
      }),
      invalidatesTags: ["Milestones"],
    }),
    syncStripeWebhooks: builder.mutation({
      query: () => ({
        url: "/donationS/admin/sync-webhooks",
        method: "POST",
      }),
    }),
  }),
});

export const {
  useGetContactMessagesQuery,
  useMarkMessageReadMutation,
  useDeleteMessageMutation,
  useGetAdminProfileQuery,
  useUpdateAdminProfileMutation,
  useChangeAdminPasswordMutation,
  useGetMilestonesQuery,
  useUpdateMilestonesMutation,
  useSyncStripeWebhooksMutation,
} = adminApiSlice;
